import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError,
} from './../feedingGuidelinesLineChartAction';
import fetchApi from "./fetchApi";

function fetchFeedingGuidelinesLineChartAction() {
  return fetchApi('/v1/fc_api/feeding_guidelines_line_chart_resource', fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchFeedingGuidelinesLineChartAction;
